import { CallIntelligenceService } from '@weave/schema-gen-ts/dist/schemas/call-intelligence/v2';
import { PhoneRecordsAPI } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-records/v1/phone_records_api.pb';
import { ListTasksRequest, TaskService } from '@weave/schema-gen-ts/dist/schemas/task-center/v1/task_service.pb';
import { QueryClient } from 'react-query';
import { MockAPIRouter } from '@frontend/fetch';
import * as CallIntelTypes from '../../types';
import { getCallMetadata, getMockTasksForCall, MockCallRecords } from '../call-recordings';
import { BaseMockRouterContext, FeatureMockRouter } from './types';

export interface CallIntelInsightPanelMockRouterContext extends BaseMockRouterContext {
  queryClient: QueryClient;
  mockCallRecordsInstance: MockCallRecords;
}

export const CallIntelInsightPanelMockRouter: FeatureMockRouter<CallIntelInsightPanelMockRouterContext> = {
  addMockRouterEndpoints: (router, { vertical, queryClient, mockCallRecordsInstance }) => {
    router.schemaEndpoint(PhoneRecordsAPI.GetHydratedCallRecord, async (request, _, next) => {
      const { searchParams } = new URL(request.url);
      const channelId = searchParams.get('channelId') ?? '';
      const locationId = searchParams.get('locationId') ?? '';

      if (!channelId.startsWith('demo')) {
        next();
        return null;
      }

      return MockAPIRouter.json({ record: { channelId, locationId } });
    });

    router.schemaEndpoint(CallIntelligenceService.GetCallMetadata, async () => {
      return MockAPIRouter.json(getCallMetadata(vertical));
    });

    router.schemaEndpoint(TaskService.ListTasks, async (request, _, next) => {
      const requestBody: ListTasksRequest = await request.clone().json();
      const filterBySourceId = requestBody.filter?.[CallIntelTypes.TaskFilterTypeEnum.FILTER_BY_SOURCE_ID];
      const callId = filterBySourceId?.sourceId?.[0] ?? '';

      if (!callId.startsWith('demo')) {
        next();
        return null;
      }

      const cachedData = queryClient.getQueryData(['demo', 'ListTasks', requestBody]);

      return MockAPIRouter.json(
        cachedData ||
          getMockTasksForCall({
            callId,
            mockCallRecordsInstance,
            vertical,
          })
      );
    });
  },
  invalidateQueries: (queryClient) => {
    queryClient.invalidateQueries(['hydrated-call-record']);
    // Other query interceptor have 'demo' key checked in request so they do not need to be invalidated
  },
};
